// Need to use the React-specific entry point to import createApi
import isBoolean from 'lodash/isBoolean';

import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const impersonationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createImpersonation: builder.mutation({
      query: ({userId}) => ({
        url: 'impersonation/',
        method: 'POST',
        body: {id: userId},
      }),
      invalidatesTags: ['*'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateImpersonationMutation
} = impersonationApi;




